export default {
  projectDesc: '基于 <strong>Vue2</strong> 强大的选择器, 可分页的列表或表格展现形式, <br>' +
  '使用标签形式的多选模式, 国际化 i18n 和服务端数据源支持',
  demo: {
    desc: '单选、多选模式，列表、简易表格展示模式',
    single: '默认单选模式',
    custom: '自定义行显示内容及禁用/启用插件',
    nopage: '关闭分页栏模式',
    modify: '动态修改选中值',
    multiple: '多选模式，设置限制最多选择 3 个以及动态修改数据源',
    tbSingle: '表格显示模式 - 单选',
    tbMultiple: '表格显示模式 - 多选',
    server: '服务端数据模式',
    serverResponse: '服务端返回数据样例',
    btnDisabled: '禁用插件',
    btnEnabled: '启用插件',
    btnModify: '修改选中的项目',
    btnChange: '修改数据源',
    useful: '实用案例',
    datasource: '数据源',
    format: '并格式化为数组',
    countries: '世界国家列表',
    timezones: '世界时区表',
    valuesEvent: '<code>values</code> 事件返回选中项目的完整数据',
    rtl: '内容及容器向右对齐'
  },
  option: {
    'v-model': '当前选中项目的值，内容对应 <code>keyField</code> 参数指定的数据字段，多选时内容使用 "," 隔开，例如："3,5,7"',
    data: '数据源指定，推荐使用静态数组；希望使用服务端数据则指定字符串类型 URL即可<br>使用服务端模式，必须在全局注册插件时，' +
      '指定 <code>dataLoad</code> 的服务端数据请求处理函数以及插件对于服务端返回数据处理的函数 <code>result-format</code> 参数',
    keyField: '指定作为键值的字段',
    showField: '指定行显示内容的字段，也可以设置 function 自定义显示内容',
    tbColumns: '表格模式数据列定义，格式如下：',
    sort: '数据排序设置，格式："字段 排序方式"，中间使用空格隔开；<br><code>asc</code>: 升序排序，<code>desc</code>: 降序排序',
    searchField: '搜索框内容查询对应的数据表字段，若未指定字段，则会默认使用 "showField" 指定的字段，该字段仅服务端数据模式有效',
    params: '服务端请求自定义参数',
    resultFormat: '服务端返回数据格式化函数，必须返回如下格式, 否则插件无法识别数据',
    selected: '指定初始化选中项目，设置的内容会与 "keyField" 字段进行匹配；多选模式若希望初始化选中多个项目则在多个值之间使用逗号隔开，例如 <code>1,2,3</code>',
    title: '标题栏显示的默认文本',
    placeholder: '插件未选中任何项目时默认提示的文本',
    maxSelectLimit: '多选模式下最多选择的项目个数',
    multiple: '多选模式，选中的项目将以标签的形式展现',
    pagination: '是否显示分页栏，关闭分页栏情况下，所有数据将在一页内显示',
    disabled: '禁用插件； <code>true</code> 禁用 <code>false</code> 启用',
    width: '设置下拉层宽度，不设置则下拉层的宽度根据内容自适应',
    rtl: '设置下拉层及内列表/表格内容右对齐，以适应部分国家/语言向右排版的需求'
  },
  event: {
    values: '返回选中项目的原始行数据',
    removed: '返回被清除的行数据'
  },
  api: {
    desc: '使用插件的 API 前，需要指定插件的 <code>ref</code> 属性，并使用 <code>this.$refs.xxx</code> 进行调用 API 方法',
    remove: '清除所有已选中的项目'
  }
}
